import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <section className="min-h-screen w-screen bg-gradient-to-b from-[#fefef8] to-[#fafae0] flex flex-col items-center Poppins">
      <Navbar />

      <div className="pt-[60px] w-full flex justify-center px-6">
        <div className="max-w-7xl w-full bg-white shadow-lg rounded-2xl border border-yellow-300 p-6 lg:p-10">
          <h1 className="text-3xl lg:text-4xl font-extrabold text-gray-800 text-center mb-6 tracking-wide">
            Privacy Policy
          </h1>
          <p className="text-center text-gray-500 mb-8">
            Last updated: <span className="font-medium">July 2026</span>
          </p>

          {/* Sections */}
          <div className="space-y-8 text-gray-700 leading-relaxed">
            <p>
              This Privacy Policy ("Policy") applies, without limitation, to
              customers/service recipients and drivers. It outlines the policies
              and procedures on the collection, use, disclosure, and protection
              of your information when you use our website,{" "}
              <a
                href="https://instaportdelivery.com"
                className="text-blue-600 hover:underline"
              >
                https://instaportdelivery.com
              </a>{" "}
              or the INSTAPORT mobile applications.
            </p>
            <p>
              At <span className="font-semibold">INSTAPORT DELIVERY</span>, your
              privacy is paramount. This statement explains how we collect and
              safeguard your data when you use our apps or website.
            </p>

            {/* What We Need */}
            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-yellow-400 pl-3 mb-3">
                What We Collect
              </h2>
              <ul className="list-disc list-inside space-y-2">
                <li>Name, contact details, and demographic information.</li>
                <li>
                  Service-related details like phone, email, billing, invoices,
                  and addresses.
                </li>
                <li>Survey/offer responses and preferences.</li>
                <li>
                  Restrictions on harmful goods: Instaport prohibits alcohol,
                  narcotics, and other unsafe items.
                </li>
                <li>
                  Sensitive data (race, ethnicity, health, biometric, etc.)
                </li>
                <li>
                  Courier details necessary to facilitate deliveries (client
                  name, location, etc.)
                </li>
              </ul>
            </div>

            {/* Actions */}
            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-yellow-400 pl-3 mb-3">
                How We Use Your Information
              </h2>
              <ul className="list-disc list-inside space-y-2">
                <li>Maintain internal records and improve services.</li>
                <li>Enable and manage transactions.</li>
                <li>Process payments securely.</li>
                <li>Provide customer support and respond to feedback.</li>
                <li>
                  Share updates, order tracking info, and promotional offers.
                </li>
              </ul>
            </div>

            {/* Description */}
            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-yellow-400 pl-3 mb-3">
                Information Sharing
              </h2>
              <p>
                We may disclose limited information to third-party services for:
              </p>
              <ul className="list-disc list-inside space-y-2 mt-2">
                <li>Improving services (location data, device info).</li>
                <li>Sharing courier or customer info to fulfill deliveries.</li>
                <li>
                  Complying with legal obligations or fraud prevention measures.
                </li>
                <li>Behavioral analytics and personalization.</li>
                <li>Supporting services with trusted vendors and partners.</li>
              </ul>
            </div>

            {/* Safety */}
            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-yellow-400 pl-3 mb-3">
                Safety & Data Protection
              </h2>
              <p>
                We implement strict{" "}
                <span className="font-medium">
                  physical, electronic, and managerial procedures
                </span>{" "}
                in compliance with Indian IT laws to safeguard your data. Data
                is retained only as long as necessary for services or legal
                obligations.
              </p>
            </div>

            {/* Cookies */}
            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-yellow-400 pl-3 mb-3">
                Cookies
              </h2>
              <p>
                We use cookies to analyze traffic, remember preferences, and
                enhance your experience. You can disable cookies in your browser
                settings, though some features may not work properly.
              </p>
            </div>

            {/* Contact */}
            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-yellow-400 pl-3 mb-3">
                Contact Us
              </h2>
              <p>
                For concerns, reach us via our support page or contact our
                Grievance Officer:
              </p>
              <div className="mt-2 bg-gray-50 p-4 rounded-lg shadow-sm text-sm">
                <p>
                  <span className="font-medium">Address:</span> Chembur, MG
                  R/3 A Wing ground floor Mass Metropolis Chembur Mumbai Maharashtra 400071
                </p>
                <p>
                  <span className="font-medium">Email:</span>{" "}
                  support@instaportdelivery.com
                </p>
                <p>
                  <span className="font-medium">Working Hours:</span> Mon–Sat : 
                  10am – 8pm, Sun : 10am - 6pm
                </p>
              </div>
            </div>

            {/* Delete Account */}
            <div>
              <h2 className="text-2xl font-semibold text-gray-800 border-l-4 border-red-400 pl-3 mb-3">
                Delete Your Account
              </h2>
              <p>
                To permanently delete your account, please visit:{" "}
                <Link
                  to="/deleteaccount"
                  className="text-red-600 font-medium hover:underline"
                >
                  Delete Account
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </section>
  );
};

export default PrivacyPolicy;

